// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"53835ec4","427":"9eb35c44","520":"f2762d07","595":"51d741b6","598":"e1590852"}[chunkId] + ".chunk.css";
};